module.exports = __webpack_public_path__ + "img/banner.761baa76.png";